var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPluslogoDuodark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 369,
    zoomAndPan: "magnify",
    viewBox: "0 0 276.75 70.499998",
    height: 94,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "68d267899d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.851562 0 L 68.265625 0 L 68.265625 67.675781 L 0.851562 67.675781 Z M 0.851562 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfa8096af5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.722656 32.664062 C 13.554688 30.785156 0.71875 20.007812 0.851562 3.679688 L 0.867188 3.175781 C 0.871094 2.8125 0.890625 2.414062 0.914062 2.191406 L 1.183594 0 L 7.578125 0 C 18.445312 0 28.167969 5.871094 33.324219 15.34375 C 32.148438 16.800781 31.101562 18.355469 30.15625 19.984375 L 29.496094 18.640625 C 25.363281 10.214844 16.964844 4.976562 7.578125 4.976562 L 5.835938 4.976562 C 6.3125 17.765625 16.695312 26.261719 26.539062 27.753906 L 26.777344 27.789062 L 25.722656 32.660156 M 37.007812 45.933594 L 38.828125 45.933594 C 55.058594 45.933594 68.261719 32.730469 68.261719 16.5 L 68.261719 8.621094 L 61.460938 8.621094 C 45.230469 8.621094 32.023438 21.828125 32.023438 38.058594 L 32.023438 67.492188 L 37 67.492188 Z M 37.007812 38.058594 C 37.007812 24.574219 47.980469 13.597656 61.464844 13.597656 L 63.285156 13.597656 L 63.285156 16.5 C 63.285156 29.984375 52.3125 40.957031 38.828125 40.957031 L 37.007812 40.957031 Z M 37.007812 38.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5cd21c4e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.207031 4.050781 L 86.351562 4.050781 L 86.351562 29.378906 L 75.207031 29.378906 Z M 75.207031 4.050781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1b2a354e8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.261719 10.125 L 77.910156 10.125 L 77.910156 4.15625 L 82.875 4.15625 L 82.875 10.125 L 86.160156 10.125 L 86.160156 13.480469 L 82.875 13.480469 L 82.875 23.636719 C 82.875 25.054688 83.660156 25.539062 84.777344 25.539062 C 85.410156 25.539062 86.269531 25.503906 86.269531 25.503906 L 86.269531 29.234375 C 86.269531 29.234375 85.109375 29.308594 83.097656 29.308594 C 80.632812 29.308594 77.90625 28.339844 77.90625 24.71875 L 77.90625 13.480469 L 75.261719 13.480469 Z M 75.261719 10.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d015de8c96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.757812 2.53125 L 106.230469 2.53125 L 106.230469 29.378906 L 88.757812 29.378906 Z M 88.757812 2.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3babb84fd3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.847656 12.628906 L 93.960938 12.628906 C 95.34375 10.613281 96.910156 9.605469 99.519531 9.605469 C 103.472656 9.605469 106.121094 12.589844 106.121094 16.769531 L 106.121094 29.273438 L 101.050781 29.273438 L 101.050781 17.511719 C 101.050781 15.457031 99.855469 14.003906 97.726562 14.003906 C 95.488281 14.003906 93.847656 15.796875 93.847656 18.410156 L 93.847656 29.273438 L 88.773438 29.273438 L 88.773438 2.585938 L 93.851562 2.585938 Z M 93.847656 12.628906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ddde662249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.265625 2.585938 L 114.339844 2.585938 L 114.339844 7.140625 L 109.265625 7.140625 Z M 109.265625 10.128906 L 114.339844 10.128906 L 114.339844 29.273438 L 109.265625 29.273438 Z M 109.265625 10.128906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e740ce1ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.363281 9.496094 L 133.457031 9.496094 L 133.457031 29.886719 L 116.363281 29.886719 Z M 116.363281 9.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72e463029d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.433594 23.078125 L 121.132812 23.078125 C 121.46875 25.277344 123.035156 26.25 125.3125 26.25 C 127.554688 26.25 128.820312 25.390625 128.820312 24.042969 C 128.820312 22.21875 126.394531 22.03125 123.78125 21.507812 C 120.347656 20.835938 116.992188 19.90625 116.992188 15.722656 C 116.992188 11.582031 120.421875 9.605469 124.789062 9.605469 C 129.824219 9.605469 132.625 12.105469 133 15.949219 L 128.414062 15.949219 C 128.191406 13.894531 126.878906 13.152344 124.71875 13.152344 C 122.742188 13.152344 121.429688 13.894531 121.429688 15.277344 C 121.429688 16.917969 123.96875 17.070312 126.695312 17.628906 C 129.902344 18.300781 133.449219 19.195312 133.449219 23.671875 C 133.449219 27.515625 130.160156 29.832031 125.386719 29.832031 C 119.828125 29.832031 116.726562 27.144531 116.433594 23.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c2ea21a46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.195312 34.179688 L 101.304688 34.179688 L 101.304688 67.113281 L 75.195312 67.113281 Z M 75.195312 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e09f82939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.261719 34.246094 L 89.664062 34.246094 C 93.472656 34.246094 96.316406 35.351562 98.246094 37.320312 C 100.078125 39.207031 101.179688 41.773438 101.179688 44.800781 C 101.179688 50.996094 97.097656 55.167969 90.214844 55.167969 L 82.144531 55.167969 L 82.144531 67.050781 L 75.261719 67.050781 Z M 82.144531 49.753906 L 89.027344 49.753906 C 92.515625 49.753906 94.347656 47.828125 94.347656 44.847656 C 94.347656 41.773438 92.421875 40.027344 89.121094 40.027344 L 82.144531 40.027344 Z M 82.144531 49.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "70c3f18aa0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.078125 34.179688 L 129 34.179688 L 129 67.113281 L 99.078125 67.113281 Z M 99.078125 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66a746ea54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.542969 34.246094 L 117.425781 34.246094 L 128.988281 67.050781 L 122.058594 67.050781 L 119.859375 60.074219 L 108.023438 60.074219 L 105.863281 67.050781 L 99.121094 67.050781 Z M 109.578125 54.980469 L 118.25 54.980469 L 115.3125 45.535156 C 114.765625 43.789062 113.984375 40.488281 113.984375 40.488281 L 113.890625 40.488281 C 113.890625 40.488281 113.0625 43.789062 112.515625 45.535156 Z M 109.578125 54.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c446e550f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.714844 34.179688 L 158.269531 34.179688 L 158.269531 67.113281 L 131.714844 67.113281 Z M 131.714844 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "300bb6659b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.746094 34.246094 L 138.488281 34.246094 L 149.410156 52.550781 C 150.464844 54.34375 151.703125 57.136719 151.703125 57.136719 L 151.796875 57.136719 C 151.796875 57.136719 151.609375 53.742188 151.609375 51.449219 L 151.609375 34.246094 L 158.171875 34.246094 L 158.171875 67.050781 L 151.742188 67.050781 L 140.550781 48.929688 C 139.492188 47.1875 138.210938 44.386719 138.210938 44.386719 L 138.117188 44.386719 C 138.117188 44.386719 138.304688 47.828125 138.304688 50.121094 L 138.304688 67.050781 L 131.746094 67.050781 Z M 131.746094 34.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47024afb9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 161.519531 34.246094 L 187.898438 34.246094 L 187.898438 39.84375 L 161.519531 39.84375 Z M 171.382812 39.84375 L 178.035156 39.84375 L 178.035156 67.050781 L 171.382812 67.050781 Z M 171.382812 39.84375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5efd127b29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.199219 34.179688 L 217.308594 34.179688 L 217.308594 67.113281 L 191.199219 67.113281 Z M 191.199219 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "73dc550f72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.253906 34.246094 L 206.296875 34.246094 C 212.625 34.246094 216.851562 37.917969 216.851562 43.375 C 216.851562 47.230469 215.058594 50.167969 210.839844 51.3125 L 210.839844 51.449219 C 213.867188 52.320312 215.425781 54.0625 215.839844 58.058594 C 216.300781 62.691406 216.113281 66.226562 217.265625 66.726562 L 217.265625 67.050781 L 210.882812 67.050781 C 210.058594 66.679688 209.964844 63.011719 209.691406 59.476562 C 209.417969 55.902344 207.398438 53.882812 203.269531 53.882812 L 197.902344 53.882812 L 197.902344 67.050781 L 191.253906 67.050781 Z M 197.902344 48.742188 L 204.96875 48.742188 C 208.589844 48.742188 210.378906 46.859375 210.378906 44.246094 C 210.378906 41.585938 208.683594 39.613281 205.148438 39.613281 L 197.902344 39.613281 Z M 197.902344 48.742188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c440cf03fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 217.753906 34.179688 L 246.382812 34.179688 L 246.382812 67.113281 L 217.753906 67.113281 Z M 217.753906 34.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36fb296476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 228.785156 54.386719 L 217.863281 34.246094 L 225.113281 34.246094 L 230.066406 43.972656 C 231.078125 45.945312 232.226562 48.652344 232.226562 48.652344 L 232.320312 48.652344 C 232.320312 48.652344 233.554688 45.945312 234.519531 43.972656 L 239.378906 34.246094 L 246.351562 34.246094 L 235.429688 54.386719 L 235.429688 67.050781 L 228.785156 67.050781 Z M 228.785156 54.386719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68f50bc10f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 248.941406 44.3125 L 275.503906 44.3125 L 275.503906 49.746094 L 248.941406 49.746094 Z M 248.941406 44.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5d3c21dc66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 259.503906 33.734375 L 264.9375 33.734375 L 264.9375 60.300781 L 259.503906 60.300781 Z M 259.503906 33.734375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68d267899d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bfa8096af5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c2c1b",
    d: "M 0.851562 0 L 68.265625 0 L 68.265625 67.414062 L 0.851562 67.414062 Z M 0.851562 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5cd21c4e9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b2a354e8d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 0 L 135.988281 0 L 135.988281 32.417969 L 72.671875 32.417969 Z M 72.671875 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d015de8c96)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3babb84fd3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 0 L 135.988281 0 L 135.988281 32.417969 L 72.671875 32.417969 Z M 72.671875 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ddde662249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 0 L 135.988281 0 L 135.988281 32.417969 L 72.671875 32.417969 Z M 72.671875 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e740ce1ed)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72e463029d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 0 L 135.988281 0 L 135.988281 32.417969 L 72.671875 32.417969 Z M 72.671875 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c2ea21a46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e09f82939)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#70c3f18aa0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66a746ea54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c446e550f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#300bb6659b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47024afb9f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5efd127b29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73dc550f72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c440cf03fc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36fb296476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 72.671875 31.660156 L 248.90625 31.660156 L 248.90625 69.636719 L 72.671875 69.636719 Z M 72.671875 31.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68f50bc10f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c2c1b",
    d: "M 248.941406 44.3125 L 275.511719 44.3125 L 275.511719 49.746094 L 248.941406 49.746094 Z M 248.941406 44.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5d3c21dc66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c2c1b",
    d: "M 259.503906 60.300781 L 259.503906 33.730469 L 264.9375 33.730469 L 264.9375 60.300781 Z M 259.503906 60.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluslogoDuodark);
export default __webpack_public_path__ + "static/media/pluslogo-duodark.7e63de3c096c449d64c89686fb02b8e8.svg";
export { ForwardRef as ReactComponent };